var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-container"},[_c('van-image',{staticClass:"image",attrs:{"fit":"widthFix","src":require('@/assets/images/banner.png')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }